export default __webpack_public_path__ + "static/section_4.1-2e7190ff3ceec35b9bd7fb261299b9c6.png";